import Webcam from "react-webcam";
import {useRef, useState} from "react";
import React from "react"
import {blobToBase64} from "../../tools/helpers";
import {useStreamManager} from "../../tools/contexts/StreamManager";
import {BsCameraVideoOff} from "react-icons/bs";
import Spinner from "../Spinner";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import bip from "../../sounds/beep.mp3"
import Countdown from "react-countdown";

const ForeignerVideoCamera = ({max, title,description, handleShowGuid, hasBack, onBack, onCapture, webcamRef, faceMode = 'environment'}) => {
    const {startStream} = useStreamManager();
    const [start, setStart] = useState(false);
    const clockRef = useRef();
    const mediaRecorderRef = React.useRef(null);
    const [recordedChunks, setRecordedChunks] = React.useState([]);
    const [isLoading, setLoading] = useState(true);
    const [cameraError, setCameraError] = useState(null);
    const handleDownload = React.useCallback(() => {
        if (recordedChunks.length) {
            const blob = new Blob(recordedChunks, {
                type: faceMode ? "video/mp4" : "video/webm"
            });
            blobToBase64(blob).then(res => {
                onCapture(res);

            });
            setRecordedChunks([]);
        }
    }, [recordedChunks]);
    const bipSound = new Audio(bip);
    const handleDataAvailable = React.useCallback(
        ({data}) => {
            if (data.size > 0) {
                setRecordedChunks((prev) => prev.concat(data));
            }
        },
        [setRecordedChunks]
    );
    const handleStopCaptureClick = React.useCallback(() => {

        if (mediaRecorderRef?.current?.state === 'inactive') return
        if (mediaRecorderRef?.current?.state === "recording") {
            mediaRecorderRef?.current?.stop();

        }


    }, [mediaRecorderRef]);
    const handleStartCaptureClick = React.useCallback(() => {

        const stream = webcamRef.current.video.srcObject;
        try {
            mediaRecorderRef.current = new MediaRecorder(stream, {
                mimeType: "video/webm"
            });
            mediaRecorderRef.current.addEventListener(
                "dataavailable",
                handleDataAvailable
            );
            mediaRecorderRef.current.start();

            bipSound.play();
            setTimeout(()=>{
                bipSound.pause();
            },1000)

        } catch (e) {

            try {

                mediaRecorderRef.current = new MediaRecorder(stream, {
                    mimeType: 'video/mp4',
                    videoBitsPerSecond: 100000
                });
                mediaRecorderRef.current.addEventListener(
                    "dataavailable",
                    handleDataAvailable
                );
                mediaRecorderRef.current.start();
            } catch (err2) {
                // If fallback doesn't work either. Log / process errors.
                console.error({e});
                console.error({err2})
            }
        }

    }, [webcamRef, handleDataAvailable, mediaRecorderRef]);

    const handleStart = () => {
        setStart(true)
        clockRef.current.start();
        handleStartCaptureClick()
    };
   const handleStop=()=>{
       setStart(false);

       bipSound.play();
       setTimeout(()=>{
           bipSound.pause();

       },1000)
       clockRef.current.stop();
       handleStopCaptureClick();
   }

    React.useEffect(() => {
        if (recordedChunks.length > 0) {
            handleDownload();
        }

    }, [handleDownload, recordedChunks]);
    const renderer = ({hours, minutes, seconds, completed}) => {
        if(!start){
            return <></>
        }
        if (completed) {
            return <span>زمان ضبط ویدیو پایان یافت</span>;
        } else {
            return (
                <span className="w-full flex justify-between items-center">

                        <span>در حال ضبط ویدیو</span>
                        <span>{hours}:{minutes}:{seconds}</span>
                     </span>
            );
        }
    };

    return <div className="w-full md:w-5/12 lg:w-4/12 mx-auto  pt-8 flex justify-center items-center flex-col">
        <div className="flex justify-center w-full mb-5 w-full flex flex-col items-center pt-4">
            {!isLoading && !cameraError && <div className="flex flex-col items-center mb-8 ">
                <h1 className="text-xl  font-bold">{title}</h1>
                <p className="px-1 text-sm text-center">{description}</p>
            </div>}
            {/*{!isLoading && !cameraError && text && <p className="text-center text-sm mb-2  text-gray-800">{text}</p>}
            {!isLoading && !cameraError &&text2 && <p className="text-center font-bold mb-5 text-sm  rounded text-green-500 ">"{text2}"</p>}*/}
            <div className="relative mt-5">
                {!isLoading && !cameraError &&<>
                  <span className="sr-only">
                        دوربین دستگاه شما فعال شده است لطفا با در نظر گرفتن نکات زیر از چهره خود ویدیو ضبط کنید.
                    </span>
                    <svg className="absolute center-guide-face" xmlns="http://www.w3.org/2000/svg" width="97"
                         height="132" viewBox="0 0 194 265">
                        <g id="Ellipse_1" data-name="Ellipse 1" fill="none" stroke="#32bc89" strokeWidth="8"
                           strokeDasharray="3 10">
                            <ellipse cx="97" cy="132.5" rx="97" ry="132.5" stroke="none"/>
                            <ellipse cx="97" cy="132.5" rx="93" ry="128.5" fill="none"/>
                        </g>
                    </svg>
                </>
                    }

                <Webcam
                    audio={true}
                    height={480}
                    width={480}
                    muted={true}
                    audioConstraints={{
                        echoCancellation: true,
                        noiseSuppression: true,
                    }}
                    onUserMedia={(stream) => {
                        setCameraError(null)
                        setLoading(false)
                        startStream(stream)
                    }}
                    onUserMediaError={(error) => {
                        if (error.toString().includes('dismissed')) {
                            setCameraError('از تنظیمات مرورگر خود، دسترسی به دوربین و میکروفون را فعال کنید و سپس صفحه را رفرش کنید.')
                        } else if (error.toString().includes('denied')) {
                            setCameraError('از تنظیمات مرورگر خود، دسترسی به دوربین و میکروفون را فعال کنید و سپس صفحه را رفرش کنید.')
                        } else if (error.toString().includes('Requested device not found')) {
                            setCameraError('دوربین یافت نشد.')
                        }
                        setLoading(false)
                    }}
                    style={{objectFit: "cover"}}
                    className="rounded-full  w-56 h-56"
                    mirrored={false}
                    videoConstraints={{
                        faceMode,
                        screenshotQuality: 1,
                        aspectRatio: 1,
                        width: {min: 480, ideal: 480},
                        height: {min: 480, ideal: 480}
                    }}
                    ref={webcamRef}
                />
            </div>
        </div>
        {isLoading && <div className="flex justify-center items-center flex-col">
            <Spinner className="text-lg text-green-500"/>

        </div>}
        {cameraError && <div
            className="w-full  rounded-lg   text-center  p-5 text-red-500  mx-auto flex flex-col justify-center  items-center  flex justify-center items-center">
            <BsCameraVideoOff className="text-5xl text-red-500"/>
            <p className=" mt-5 w-full text-center">{cameraError}</p>
        </div>}
        {!isLoading && !cameraError &&<div className="w-full flex flex-col items-center justify-center ">
            {!start && <div className="w-full md:h-36 ">
                <p className="w-full mt-2 mb-1 text-green-500 font-bold ">در هنگام ضبط ویدیو، نکات زیر را رعایت کنید.</p>
                <ol className="list-inside w-full list-disc">
                    <li className="font-semibold mb-2 text-sm">عینک خود را بردارید.</li>
                    <li className="font-semibold mb-2 text-sm">از ماسک استفاده نکنید.</li>
                    <li className="font-semibold mb-2 text-sm">چهره‌تان باید کاملاً درون کادر قرار گیرد.</li>
                    <li className="font-semibold mb-2 text-sm">در نور کافی ویدیو ضبط کنید.</li>
                </ol>
            </div>}
            {start && <div className="w-full flex flex-col justify-center items-center md:h-36 ">
                <h1 className="text-center mt-3  font-semibold">در حال ضبط ویدیو</h1>
                <p className="text-sm text-center ">لطفاً دقت کنید که چهره‌تان در تمام مدت داخل کادر باشد تا بتوانیم بهترین نتیجه را دریافت کنیم.</p>
            </div>}
            <div className="w-full fixed md:relative bottom-0 bg-white md:bg-transparent py-2 left-0 px-2 ">
                <Button
                    disabled={start}
                    rounded="rounded-xl"
                    theme={start ? "red" : "green"}
                    className="z-20 p-3  md:mt-5 w-full text-sm transition duration-200  "
                    onClick={handleStart}>
                    {<Countdown
                        autoStart={false}
                        ref={clockRef}
                        onComplete={handleStop}
                        date={Date.now() + max*1000} // 10 seconds countdown
                        renderer={renderer}
                    />  }
                    {!start && "شروع ضبط ویدیو"}
                </Button>
            </div>
        </div>

        }


    </div>
}
export default ForeignerVideoCamera